{
  "el": {
    "question": {
      "actions": {
        "addDocuments": "Προσθήκη εγγράφων",
        "cancel": "Ακύρωση",
        "createQuestion": "Δημιουργία ερώτησης",
        "delete": "Διαγραφή",
        "deleteDocuments": "Διαγραφή εγγράφων",
        "edit": "Επεξεργασία",
        "moveDown": "Μετακίνηση κάτω",
        "moveUp": "Μετακίνηση πάνω",
        "new": "Ερώτηση",
        "save": "Αποθήκευση"
      },
      "attributes": {
        "answer": "Απάντηση",
        "documents": "Έγγραφα / Εικόνες",
        "name": "Ερώτηση",
        "question": "Ερώτηση"
      },
      "labels": {
        "editQuestion": "Επεξεργασία ερώτησης",
        "newQuestion": "Νέα ερώτηση"
      },
      "toasts": {
        "create": "Η ερώτηση δημιουργήθηκε",
        "delete": "Η ερώτηση διαγράφηκε",
        "update": "Η ερώτηση ενημερώθηκε"
      },
      "validation": {
        "needAnswer": "Απαιτείται απάντηση",
        "needQuestion": "Απαιτείται ερώτηση"
      }
    }
  }
}
